module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"delete":"Retirer"}}')
  delete Component.options._Ctor
}
